/**
 * Whether following a link takes the viewer off the platform (XN-4691). The
 * platform is this hub's host less its first label — agencyhub.dev.xtendlive.com
 * → dev.xtendlive.com, as the session cookie is scoped — and every host under
 * it. An address that does not parse counts as leaving.
 */
// ponytail: a hub served on an agency's own domain would count that domain's
// other sites as the platform; read a configured platform domain if hubs get one.
export function leavesPlatform(href, hostname = window.location.hostname) {
  let host;
  try {
    host = new URL(href).hostname;
  } catch {
    return true;
  }
  if (host === hostname) return false;
  const platform = hostname.split('.').slice(1).join('.');
  return !platform || (host !== platform && !host.endsWith(`.${platform}`));
}
